// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__dmNz0","modalQuestionWrapper":"styles_modalQuestionWrapper__SsXx+","urlWrapper":"styles_urlWrapper__YfiHS"};